/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

*/

(function ($) {

// Responsive tables init

$(document).ready(function() {
    $('form#cartform').on('click', 'button.qty-plus', function() {
        $( "input#update_quantities" ).trigger('click');
    });
    $('form#cartform').on('click', 'button.qty-minus', function() {
        $( "input#update_quantities" ).trigger('click');
    });

	$('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');

//   CUSTOM CODES
    $('.flexslider-logo').flexslider({
      animation: "slide",
      animationLoop: false,
      directionNav: true,
      controlNav: false,
      itemWidth: 210,
      itemMargin: 5,
      minItems: 2,
      maxItems: 4
    });
    // PRODUCT TABS
	$('ul.tabs').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
          $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function(e){
          active.removeClass('active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('active');
          content.show();
          return false;
        });
      });
      var stringSize;
      $('div.meta-tabs').each(function(){
        stringSize = $(this).html().replace(/ /g,'');
        if(stringSize.length > 2){}else{
        	$(this).hide();
          	$('ul.tabs li a.'+$(this).attr('id')).parents('li').hide();
        }
      });

      var tabs = $('ul.tabs');
      tabs.each(function(i) {
        var tab = $(this).find('> li > a');
        tab.click(function(e) {
          var contentLocation = $(this).attr('href');
          if(contentLocation.charAt(0)=="#") {
            e.preventDefault();
            tab.removeClass('active');
            $(this).addClass('active');
            $(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
          }
        });
      });

      $('div.swatch-wrapper input[type="radio"]').click(function(){
         $('.form-control').val($(this).val()).change();
      });
});

$(document).ready(function(){$(".sca-qv-button").eq(0).bind("DOMSubtreeModified",function(){$(this).unbind("DOMSubtreeModified"),$(".scaqv-quickadd").show()}),$(".sca-qv-cartbtn-custom").not('.sca-qv-cartbtn-custom[class*="disabled"]').click(function(){var d=$(this);d.hide();var i=d.parent();$(".scaqv-added",i).css("display","inline-block"),setTimeout(function(){d.css("display","inline-block"),d.removeClass("disabled"),$(".scaqv-added",i).hide()},2e3)}),$("img").addClass("lazyload")});
function sca_default_callback_function($, product){
            $(".sca-qv-cartbtn.sca-qv-cartbtn-config").val("ADD TO CART");
        	$("#sca-qv-variant-options .selector-wrapper select").change(function () {
      			$(".sca-qv-cartbtn.sca-qv-cartbtn-config").val("ADD TO CART");
    		});
}
// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu

$("select#mobile-menu").on('change', function() {
  window.location = $(this).find("option:selected").val();
});

// FancyBox

$(document).ready(function() {
	$(".fancybox").fancybox();
});

// Login Boxes

$("#forgot-password-box").on('click', function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").on('click', function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

$(document).ready(function() {
    if (document.querySelector(".resetSuccessful")) {
        $('#resetSuccess').show();
    }
});

// Drawers

var MOBILE_DRAWER_SIZE = 300,
    DESKTOP_DRAWER_SIZE = 390,
    MOBILE_WIDTH_MAX = 768;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).on('resize', function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    if (!window.slideouts.right) {
        // cart slider is disabled
        return;
    }

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});


function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        if (hidden_menu) {
            hidden_menu.classList.add('slideout-panel-hidden');
        }
        $overlay.fadeIn();
        // document.body.style.overflowY = 'hidden';
        var marginTop = $(window).scrollTop() + 'px';
        panel.style.position = 'fixed';
        panel.style.marginTop = '-' + marginTop;
        // Apply oposite effect to the sticky header
        $('.sticky-header-wrapper.sticky').css({
            'margin-top': marginTop,
            'transform': 'translateY(0)'
        });
    });

    slideout.on('beforeclose', function () {
        $overlay.fadeOut();
        var scrollTop = -parseInt(panel.style.marginTop);
        panel.style.position = '';
        panel.style.marginTop = '';
        $(window).scrollTop(scrollTop);
    });

    slideout.on('close', function() {
        $('.sticky-header-wrapper').css({
            'margin-top': 0,
            'transform': ''
        });
        menu.classList.add('slideout-panel-hidden');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        if (hidden_menu) {
            hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
        }
    });

    return slideout;
}

function load_menu_drawer() {

    // Close sliders if they're open
    if (window.slideouts && window.slideouts.left) {
        window.slideouts.left.close();
    }
    if (window.slideouts && window.slideouts.right) {
        window.slideouts.right.close();
    }

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    var body_menu = $('body > #theme-menu');
    var main_body_menu = $('#main-body #theme-menu');
    if (main_body_menu.length > 0) {
        body_menu.remove();
        $('body').append(main_body_menu);
    }

    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#theme-menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    if (!main_body || !left_menu || !overlay) {
        return;
    }

    /* Mobile Menu */

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').off('click').on('click', function() {
        slideoutLeft.toggle();
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    if (!right_menu) {
        // Cart drawer is disabled in the settings
        return;
    }
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').off('click').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('form#add-to-cart-form button#purchase').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
}

$(document).ready(load_menu_drawer);
document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});

// Google Maps JS
// $(document).ready(function() {
//     $('form#add-to-cart-form').find('#purchase').on('click', function (e) {
//         setTimeout(() => {
//             $('.slide-menu-cart').trigger('click');
//         }, 4000);
//     });
// });

// Set map Variables
var MAP_SELECTOR = '.map-wrapper';
var MAP_API_FAILED = false;
var map_objects = [];

function set_map_error(message, container) {
    if (!container) {
        container = $('.map-section__container');
    }
    container.addClass('hide');
    if (Shopify.designMode) {
        $('<div class="map-container-error"></div>').text(message).appendTo(container.parent().find('.map-section__overlay'));
    }
    container.parent().find('.homepage-map--fallback').removeClass('hide');
}

function maps_resize() {
    // Center map when screensize is changed
    map_objects.forEach(function (map) {
        var currCenter = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(currCenter);
    });
}

function map_init(map_element) {
    var config = {
      zoom: 14
    };

    var section = map_element.dataset.id;
    var colors = map_element.dataset.colors;
    var style = [];
    try {
        var styleElement = document.getElementById('homepage-map--theme--' + section);
        if (styleElement) {
            style = JSON.parse(styleElement.textContent);
        }
    } catch (e) {
        console.error('Unable to parse theme style:', e);
    }
    var container = document.querySelector('#map-container-' + section);
    if (!container) {
        return;
    }
    var $container = $(container);
    if (MAP_API_FAILED) {
        set_map_error('Google Maps authentication error, API key might be invalid', $container);
    }

    var map = new google.maps.Map(container, {
        zoom: config.zoom,
        styles: style,
        disableDefaultUI: true,
        draggable: false,
        clickableIcons: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        draggableCursor: 'default'
    });
    map_objects.push(map);

    var geocoder = new google.maps.Geocoder();

    geocodeAddress(geocoder, map);

    function geocodeAddress(geocoder, resultsMap) {
        var address = $('#map-container-' + section).data('address-setting');
        geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
                resultsMap.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: resultsMap,
                    position: results[0].geometry.location
                });
            } else {
                set_map_error('Error looking up that address', $container);
            }
        });
    }
}

// Google Map JS
function load_googlemaps() {
  var mapElements = document.querySelectorAll(MAP_SELECTOR);
  if (mapElements.length === 0) {
      // No map element on the page, don't load the map API
      return;
  }

  var apiKey = null;
  Array.prototype.forEach.call(mapElements, function (map_element) {
    var section = map_element.dataset.id;
    var apiKeyInput = document.querySelector('#apikey-' + section);
    var elementApiKey = apiKeyInput ? apiKeyInput.value : '';
    if (!elementApiKey) {
        return;
    }
    if (apiKey && elementApiKey && elementApiKey !== apiKey) {
        console.warn('Multiple different Google Maps API keys are not allowed, using only the first one');
        return;
    }
    apiKey = elementApiKey;
  });
  if (!apiKey) {
    console.error('Google Maps API key not provided!');
    set_map_error('Google Maps API key not provided!', null);
    return;
  }

  if (MAP_API_FAILED || !window.google || !window.google.maps || !window.google.maps.Geocoder || !window.google.maps.Map) {
    MAP_API_FAILED = false;
    $.getScript(
        'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=google_maps_loaded'
    );
  } else {
    window.google_maps_loaded();
  }
}

window.google_maps_loaded = function () {
    Array.prototype.forEach.call(document.querySelectorAll(MAP_SELECTOR), map_init);
    $(window).off('resize', maps_resize).on('resize', maps_resize);
}

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars

window.gm_authFailure = function () {
  MAP_API_FAILED = true;
  console.error('Authentication Failure');

  var $container = $('.map-section__container');

  set_map_error('Google Maps authentication error, API key might be invalid', null);
}

document.addEventListener('shopify:section:load', load_googlemaps);

$(document).ready(load_googlemaps);

})(window.wetheme.$);



/* Start Customer Colleciton filters */
console.log('custom.js');
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        console.log('running 2');

        var openButton = document.getElementById('OpenCollectionFilters');
        var closeButton = document.getElementById('CloseCollectionFilters');
        var filtersColumn = document.getElementById('CollectionFiltersColumn');
        var backdrop = document.getElementById('CollectionFiltersBackdrop');
        var filtersForm = document.getElementById('CollectionFiltersForm');

        console.log('filtersForm',filtersForm);


        function openFilters() {
            if (!filtersColumn) return;
            filtersColumn.classList.add('is-open');
            if (backdrop) backdrop.classList.add('is-open');
            if (openButton) openButton.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('collection-filters-open');
            document.body.classList.add('collection-filters-open');
        }

        function closeFilters() {
            if (!filtersColumn) return;
            filtersColumn.classList.remove('is-open');
            if (backdrop) backdrop.classList.remove('is-open');
            if (openButton) openButton.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove('collection-filters-open');
            document.body.classList.remove('collection-filters-open');
        }

        if (openButton) {
            openButton.addEventListener('click', openFilters);
        }

        if (closeButton) {
            closeButton.addEventListener('click', closeFilters);
        }

        if (backdrop) {
            backdrop.addEventListener('click', closeFilters);
        }

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
            closeFilters();
            }
        });

        if (filtersForm) {
            var priceTimer;

            console.log('has filters')

            filtersForm.addEventListener('change', function(event) {
                console.log('filter change');
            var target = event.target;
            if (!target) return;

            if (target.matches('input[type="checkbox"]')) {
                filtersForm.submit();
                return;
            }

            if (target.matches('select')) {
                filtersForm.submit();
                return;
            }

            if (target.matches('input[type="number"]')) {
                clearTimeout(priceTimer);
                priceTimer = setTimeout(function() {
                filtersForm.submit();
                }, 500);
            }
            });

            filtersForm.addEventListener('input', function(event) {
            var target = event.target;
            if (!target) return;

            if (target.matches('input[type="number"]')) {
                clearTimeout(priceTimer);
                priceTimer = setTimeout(function() {
                filtersForm.submit();
                }, 700);
            }
            });
        }
    });
    })();

    /* end collection filters */


document.addEventListener('DOMContentLoaded', function () {

    var acc = document.getElementsByClassName("accordion");
    var i;
    console.log('acc',acc)

    console.log('test',acc.length)

    for (i = 0; i < acc.length; i++) {
        console.log('hello',i)
    acc[i].addEventListener("click", function() {
        console.log('clicked');
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
    }
});



(function () {
  function DesktopProductGalleryLightbox(gallery) {
    this.gallery = gallery;
    this.productRoot = gallery.closest('[data-section-id]');
    this.lightbox = document.querySelector('.product-gallery-lightbox');

    if (!this.productRoot || !this.lightbox) return;

    this.swiperEl = this.lightbox.querySelector('.product-gallery-lightbox__swiper');
    this.closeBtn = this.lightbox.querySelector('.product-gallery-lightbox__close');
    this.backdrop = this.lightbox.querySelector('.product-gallery-lightbox__backdrop');
    this.prevBtn = this.lightbox.querySelector('.product-gallery-lightbox__prev');
    this.nextBtn = this.lightbox.querySelector('.product-gallery-lightbox__next');
    this.swiper = null;

    if (!this.swiperEl) return;

    this.bindEvents();
  }

  DesktopProductGalleryLightbox.prototype.isDesktop = function () {
    return window.innerWidth >= 769;
  };

  DesktopProductGalleryLightbox.prototype.open = function (index) {
    this.lightbox.hidden = false;

    document.documentElement.classList.add('product-gallery-lightbox-open');
    document.body.classList.add('product-gallery-lightbox-open');

    if (!this.swiper) {
      this.swiper = new Swiper(this.swiperEl, {
        initialSlide: index,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          prevEl: this.prevBtn,
          nextEl: this.nextBtn
        }
      });
    } else {
      this.swiper.update();
      this.swiper.slideTo(index, 0);
    }
  };

  DesktopProductGalleryLightbox.prototype.close = function () {
    this.lightbox.hidden = true;

    document.documentElement.classList.remove('product-gallery-lightbox-open');
    document.body.classList.remove('product-gallery-lightbox-open');

    this.lightbox.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (e) {}
    });

    this.lightbox.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.src;
      iframe.src = src;
    });
  };

  DesktopProductGalleryLightbox.prototype.bindEvents = function () {
    this.productRoot.addEventListener('click', function (event) {
      var thumb = event.target.closest('.product-single__thumbnail:not(.swiper-slide-duplicate)');

      if (!thumb) return;
      if (!this.gallery.contains(thumb)) return;
      if (!this.isDesktop()) return;

      if (
        event.target.classList.contains('product-single__view-in-space') ||
        event.target.classList.contains('plyr__control') ||
        event.target.classList.contains('shopify-model-viewer-ui__button') ||
        event.target.tagName === 'MODEL-VIEWER'
      ) {
        return;
      }

      var index = Number(thumb.dataset.galleryIndex || 0);

      setTimeout(function () {
        this.open(index);
      }.bind(this), 0);
    }.bind(this));

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', this.close.bind(this));
    }

    document.addEventListener('keydown', function (event) {
      if (this.lightbox.hidden) return;

      if (event.key === 'Escape') {
        this.close();
      }

      if (event.key === 'ArrowLeft' && this.swiper) {
        this.swiper.slidePrev();
      }

      if (event.key === 'ArrowRight' && this.swiper) {
        this.swiper.slideNext();
      }
    }.bind(this));
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-gallery--desktop-grid').forEach(function (gallery) {
      new DesktopProductGalleryLightbox(gallery);
    });
  });
})();

/* Product Page How To Video Controls */
document.addEventListener('click', function(event) {
  const button = event.target.closest('.feature-row__play-button');
  if (!button) return;

  const wrapper = button.closest('.feature-row__media--deferred-video');
  if (!wrapper) return;

  const template = wrapper.querySelector('template');
  if (!template) return;

  wrapper.innerHTML = template.innerHTML;

  const video = wrapper.querySelector('video');
  if (video) {
    video.play().catch(() => {});
  }
});

/* Collection Page Read more description button */

document.addEventListener('click', function(event) {
  const readMoreButton = event.target.closest('.btn__readmore');
  const hideButton = event.target.closest('.btn__hide');
  const description = event.target.closest('.description-content');

  if (!readMoreButton && !hideButton && !description) return;

  const collapsedContent = description.querySelector('.desc__collapse');
  const expandedContent = description.querySelector('.desc__expand');

  if (readMoreButton) {
    collapsedContent.hidden = true;
    expandedContent.hidden = false;
  }

  if (hideButton) {
    collapsedContent.hidden = false;
    expandedContent.hidden = true;
    description.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});